import axios from '../utils/request/request'
const feedBack = {
    // 意见反馈列表
    feedBackList: params => axios.post('/frontend/feedback/', params),
    // 意见反馈详情
    feedBackDetail: params => axios.post('/frontend/feedback/detail', params),
    // 意见反馈提交
    feedBackAdd: params => axios.post('/frontend/feedback/add', params)
}
export default feedBack